import { Target, Sparkles, ShieldCheck, HeartHandshake } from "lucide-react";

const OFFICE_IMG = "https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2UlMjBwcm9mZXNzaW9uYWwlMjBjYXJlZXJ8ZW58MHx8fHwxNzg4Njc1Mzg1fDA&ixlib=rb-4.1.0&q=85";

const pillars = [
  { title: "Our Mission", desc: "Help every job seeker land a role that respects their skills, time, and ambitions — no ghosting, no noise.", Icon: Target },
  { title: "Why Choose Us", desc: "A human-first recruitment team backed by curated data, so you never scroll through irrelevant listings.", Icon: Sparkles },
  { title: "Career Support", desc: "Free resume reviews, mock interviews, and salary negotiation coaching from industry experts.", Icon: HeartHandshake },
  { title: "Trusted Opportunities", desc: "Every listing is vetted with the employer before it reaches you. No spam. No dead links.", Icon: ShieldCheck },
];

export default function About() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-600">About CareerConnect</p>
            <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 font-display">
              We help talent find work worth doing.
            </h1>
            <p className="mt-5 text-slate-600 leading-relaxed">
              CareerConnect is a modern recruitment platform built for the way people actually job hunt today — fast, honest, and human. We started with one belief: matching people to great roles shouldn&apos;t feel like a numbers game.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Since 2021, we&apos;ve placed 38,000+ professionals across engineering, design, marketing, sales, and operations at companies of every stage — from Series A rockets to global brands.
            </p>
            <div className="mt-8 grid grid-cols-3 gap-4">
              {[{ n: "38K+", l: "Placements" }, { n: "1.2K", l: "Partners" }, { n: "48h", l: "Avg. Response" }].map((s) => (
                <div key={s.l} className="bg-white border border-slate-200 rounded-2xl p-4">
                  <p className="text-2xl font-extrabold text-slate-900 font-display">{s.n}</p>
                  <p className="text-xs text-slate-500 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-6 relative">
            <div className="absolute -inset-6 bg-gradient-to-br from-blue-500/20 to-sky-400/20 rounded-3xl blur-2xl" />
            <img src={OFFICE_IMG} alt="Modern workspace" className="relative rounded-3xl shadow-xl border border-white/60 w-full h-[440px] object-cover" />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 lg:pb-24">
        <div className="grid md:grid-cols-2 gap-6">
          {pillars.map(({ title, desc, Icon }) => (
            <div key={title} data-testid={`about-pillar-${title.toLowerCase().replace(/\s+/g, "-")}`} className="card-hover bg-white border border-slate-200 rounded-2xl p-8">
              <span className="inline-flex w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-700 items-center justify-center">
                <Icon size={22} />
              </span>
              <h3 className="mt-5 text-xl font-semibold text-slate-900 font-display">{title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
